export const styles = {
  button: {
    width: 25,
    height: "25px !important",
    border: "1px solid",
    borderColor: "events.blueSecondary",
  },
  listItem: {
    height: 51,
    width: 200,
    "&:hover": {
      color: "events.whiteTertiary",
      backgroundColor: "events.bluePrimary",
    },
  },
};
